export const parseObjectToString = params => Object.entries(params).filter(_ref => {
  let [key, value] = _ref;
  return value !== undefined && value !== '';
}).map(_ref2 => {
  let [key, value] = _ref2;
  if (key === 'cdn-operations') {
    return value;
  }
  if (key === 'analytics') {
    return value;
  }
  return "".concat(key, "/").concat(value);
});